import { useEffect, useMemo, useState } from "react";
import { Modal, Input, Typography, Button, Divider } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { Notification } from "../Notification";

const { Paragraph } = Typography;

export default function UpdateClientModal({ data, opened, setOpened, setNullKeys }) {
  const [visible, setVisible] = useState(false);
  const [openedBefore, setOpenedBefore] = useState(false);
  const [updatedData, setUpdatedData] = useState({});

  //checks for the null keys
  const nullKeys = useMemo(() => {
    const orderedKeys = ["accountant", "accountantEmail", "accountantNumber", "deliveryAddress", "deliveryAddress2", "bankName", "bankCode", "accountNumber"];
    return data ? orderedKeys.filter((key) => !data[key] && orderedKeys.includes(key)) : [];
  }, [data]);

  //handles the data update
  const handleOk = () => {
    updateDocData();
  };

  //updates doc
  const updateDocData = async () => {
    //doc ref
    const ref = doc(db, "clients", data.id);
    console.log(data.id);
    //Approve the price
    await updateDoc(ref, updatedData)
      .then(() => {
        Notification("success", "Updated!", "Price has been approved!");
      })
      .then(() => {
        setVisible(false);
        setUpdatedData({});
      })
      .catch((err) => {
        Notification("error", "Login Error", err.message);
      });
  };

  //updates opened before state from parent
  useEffect(() => {
    setOpenedBefore(opened);
  }, [opened]);

  //cancels
  const handleCancel = () => {
    setVisible(false);
    setOpenedBefore(true);
    setOpened(true);
    setUpdatedData({});
  };

  //updates the data
  const updateData = (key, value) => {
    setUpdatedData({ ...updatedData, [key]: value });
  };

  //checks if there are any null values and updates parents and childs openedBefore state
  useEffect(() => {
    if (nullKeys.length > 0 && !openedBefore) {
      setVisible(true);
      setOpenedBefore(true);
      setOpened(true);
    }
    //checks if there are any null keys and sends to parent
    if (nullKeys.length > 0) {
      setNullKeys(true);
    } else {
      setNullKeys(false);
    }
  }, [nullKeys, openedBefore, setOpened, setNullKeys]);

  //returns the proper element and label
  const returnProperLayour = (key) => {
    switch (key) {
      case "accountant":
        return (
          <>
            <Divider>Accounting Info</Divider>
            <label>Accountant :</label>
            <Input value={updatedData[key] || ""} placeholder="Juris Gramatvedis" onChange={(e) => updateData(key, e.target.value)} />
          </>
        );
      case "accountantEmail":
        return (
          <>
            <label>Accountant Email:</label>
            <Input value={updatedData[key] || ""} placeholder="gramatvede@test.lv" onChange={(e) => updateData(key, e.target.value)} />
          </>
        );
      case "accountantNumber":
        return (
          <>
            <label>Accountant Phone Number :</label>
            <Input value={updatedData[key] || ""} placeholder="+371 254343444" onChange={(e) => updateData(key, e.target.value)} />
          </>
        );
      case "deliveryAddress":
        return (
          <>
            <Divider>Delivery Info</Divider>
            <label>Delivery Address :</label>
            <Input value={updatedData[key] || ""} placeholder="Pernavas iela 55, Riga, LV-1009" onChange={(e) => updateData(key, e.target.value)} />
          </>
        );
      case "deliveryAddress2":
        return (
          <>
            <label>Second Delivery Address :</label>
            <Input value={updatedData[key] || ""} placeholder="Pernavas iela 55, Riga, LV-1009" onChange={(e) => updateData(key, e.target.value)} />
          </>
        );
      case "bankName":
        return (
          <>
            <Divider>Bank Info</Divider>
            <label>Bank Name :</label>
            <Input value={updatedData[key] || ""} placeholder="AS `Swedbank`" onChange={(e) => updateData(key, e.target.value)} />
          </>
        );
      case "bankCode":
        return (
          <>
            <label>Bank Code :</label>
            <Input value={updatedData[key] || ""} placeholder="HABALV20" onChange={(e) => updateData(key, e.target.value)} />
          </>
        );
      case "accountNumber":
        return (
          <>
            <label>Bank Account Number :</label>
            <Input value={updatedData[key] || ""} placeholder="LV16HABA0552054382294" onChange={(e) => updateData(key, e.target.value)} />
          </>
        );
      default:
        return (
          <>
            <label>{key}:</label>
            <Input value={updatedData[key] || ""} onChange={(e) => updateData(key, e.target.value)} />
          </>
        );
    }
  };

  return (
    <>
      {nullKeys.length > 0 && nullKeys.length > 0 && (
        <Button type="primary" danger onClick={() => setVisible(true)}>
          <InfoCircleOutlined /> Update
        </Button>
      )}
      <Modal
        title={`Please update data for client : ${data && data.client ? data.client : ""}`}
        open={visible}
        onOk={handleOk}
        okText="Update Data"
        onCancel={handleCancel}
      >
        <Paragraph italic type="danger">
          Please fill out this information about the client before you proceed with creating an order. If this informations is left empty, you won't be able to
          proceed with the order!
        </Paragraph>
        {nullKeys.map((key) => (
          <div key={key} style={{ marginBottom: 10 }}>
            {returnProperLayour(key)}
          </div>
        ))}
      </Modal>
    </>
  );
}
